import { LangEnum } from './config';
import React, { FC, useEffect } from 'react';

interface IPOConfigProps {
  lang: LangEnum;
}

export const IPOConfig: FC<IPOConfigProps> = ({ lang }) => {

  useEffect(() => {
    console.log(lang);
  }, [lang])
  

	return (
		<>
      de
    </>
	);
};